import { AuthService } from './auth.service';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(authService, _window) {
        this.authService = authService;
        this._window = _window;
    }
    AuthGuard.prototype.canActivate = function (route) {
        var param = this._window.location.search.substr(1);
        if (param.indexOf("error") >= 0) {
            this.authService.errorLogin();
            return false;
        }
        this.token = this.authService.getTokenFromURL(param, route);
        var accessModel = this.authService.validateAccessModel();
        if (!accessModel) {
            if (!this.token) {
                this.authService.authenticateOnOpenId();
                return false;
            }
            return this.authService.createAccessModel(this.token);
        }
        return true;
    };
    return AuthGuard;
}());
export { AuthGuard };
